import React, { useEffect, useState } from "react";
import { api, bg } from "@/lib/api";
import { Outlet, Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";
import { UserMenu } from "@/components/UserMenu";
import { InstallBanner } from "@/components/InstallApp";
import { AvisoEndereco, enderecoJaVisto } from "@/components/AvisoEndereco";
import { InnovaIAAluna } from "@/components/InnovaIAAluna";

export default function InstructorLayout() {
  const { user } = useAuth();
  // aba "Dúvidas da IA": só aparece quando chegou alguma dúvida de aluna
  const [duvidas, setDuvidas] = useState(null);
  useEffect(() => { api.get("/prof/innova-ia/duvidas", bg).then((r) => setDuvidas(r.data)).catch(() => {}); }, []);
  const profileLabel = { professor: "Professor(a)", instrutor: "Instrutor(a)", mentor: "Mentor(a)", representante: "Representante Credenciado" }[user?.profile] || "Professor(a)";

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="h-16 sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 px-4 sm:px-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Link to="/prof"><Brand size="md" variant="membros" /></Link>
          <span className="hidden sm:inline-flex text-[10px] font-mono uppercase tracking-wider text-[#1E9E2A] bg-green-50 border border-green-100 px-2 py-1 rounded-md">
            {profileLabel}
          </span>
        </div>
        <UserMenu />
      </header>
      <AvisoEndereco />
      <InstallBanner depois={!enderecoJaVisto()} />   {/* um aviso por vez: primeiro o do endereço */}
      {/* mesma tela do aluno (cursos e aulas) + as funções de professora/mentora */}
      <nav className="max-w-6xl mx-auto w-full px-5 md:px-8 pt-5 flex gap-1" data-testid="prof-tabs">
        <div className="flex gap-1 bg-slate-100 rounded-lg p-1 overflow-x-auto">
          {[["/prof", "Cursos e aulas", true], ["/prof/turmas", "Minhas turmas", false],
            ...((user?.permissions || []).includes("cadastro") ? [["/prof/alunos", "Alunos", false]] : []),
            ...((user?.permissions || []).includes("vendas") ? [["/prof/vendas", "Links de venda", false]] : []),
            ...((user?.permissions || []).includes("cobrancas") ? [["/prof/cobrancas", "Cobranças", false]] : []),
            ...(duvidas?.itens?.length ? [["/prof/duvidas-ia", `Dúvidas da IA${duvidas.abertas ? ` (${duvidas.abertas})` : ""}`, false]] : [])].map(([to, label, end]) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) => `px-4 py-1.5 rounded-md text-sm font-medium whitespace-nowrap ${isActive ? "bg-white text-[#232D4F] shadow-sm" : "text-slate-500"}`}>
              {label}
            </NavLink>
          ))}
        </div>
      </nav>
      <Outlet />
      <InnovaIAAluna key={`${user?.id || ""}-${user?.role || ""}`} />   {/* só aparece se o admin ativou a In'Nova IA para esta professora */}
    </div>
  );
}
